import { BaseComponent } from '../../base-component';
import { shoppingAssistant } from '@otto-ec/nexus-registry/shoppingAssistant';

export class ShoppingAssistantComponent extends BaseComponent {
    public rootSelector = '.js_pdp_shopping-assistant';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }

        shoppingAssistant.provideContext({
            type: 'productDetailPage',
            variationId,
        });
    }
}
